import React, { useState, useEffect } from "react";
import { Spin } from "antd";
import { ErrorMessage, Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomPhoneInput from "../../../CustomControls/CustomPhoneInput";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomMultiSelect from "../../../CustomControls/CustomMultiSelect";
import swal from "sweetalert";
import img200 from "../../../../images/avatar/DefaultUserPhoto.jpg";
import { SVGICON } from "../../../constant/theme";
import {
  ActiveInactive_Record,
  capitalizeString,
  delete_Record,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import {
  POST_GetMachinesDetailByID,
  POST_GetMaterialCategoryDropDownListByCategoryType,
  POST_MachineParametersActiveInActive,
  POST_MachineParametersDelete,
  POST_MachinesActiveInActive,
  POST_MachinesDelete,
  POST_MachinesInsert,
  POST_MachinesUpdate,
} from "../../../helpers/url_helper";
import { post, postFormData } from "../../../helpers/api_helper";

const AddMachines = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam } = useParams();
  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  const [machineImage, setMachineImage] = useState(null);
  const [machineImageFile, setMachineImageFile] = useState(null);
  const [userManualFilePath, setUserManualFilePath] = useState(null);
  const [userManualFilePathFile, setUserManualFilePathFile] = useState(null);
  const [machineGroupOptions, setMachineGroupOptions] = useState([]);

  const validationSchema = Yup.object().shape({
    MachineName: Yup.string().trim().required("Machine Name is required field"),

    CalibrationValidity: Yup.string().when(
      "IsCalibrationValidity",
      ([IsCalibrationValidity], schema) => {
        if (IsCalibrationValidity == true)
          return Yup.string().required(
            "Calibration Validity is required field",
          );
        return schema;
      },
    ),

    // ManufacturingCompany: Yup.string()
    //   .trim()
    //   .required("Manufacturing Company is required field"),
    // SerialNo: Yup.string().trim().required("Serial No is required field"),
    // MachineNumber: Yup.string()
    //   .trim()
    //   .required("Machine Number is required field"),
    // CalibrationValidity: Yup.string()
    //   .trim()
    //   .required("Calibration Validity is required field"),
    // MachineRange: Yup.string()
    //   .trim()
    //   .required("Machine Range is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      MachineIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      MachineName: "",
      ManufacturingCompany: "",
      SerialNo: "",
      MachineNumber: "",
      CalibrationValidity: "",
      Remarks: "",
      MachineRange: "",
      UserManualFilePath: "",
      MachineImage: "",
      ListMachineParameters: [],
      MachineParameter: "",
      IsActive: true,
      MachineImageURL: "",
      UserManualFilePathURL: "",
      actionFlag: 0, // 0 = Add,  1 = edit
      indx: "",
      MachineParameterID: "",
      IsCalibrationValidity: false,
      //MachineGroupIDEncrypt: "",
      MachineGroupIDs: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      ListMachineParameters,
      MachineParameter,
      actionFlag,
      indx,
      MachineIDEncrypt,
      UserManualFilePath,
      MachineParameterID,
      IsCalibrationValidity,
      CalibrationValidity,
      //MachineGroupIDEncrypt,
      MachineGroupIDs,
    },
  } = formik;

  const handleValidSubmit = (values) => {
    setIsLoading(true);
    let formData = new FormData();

    formData.append("MachineIDEncrypt", MachineIDEncrypt);
    formData.append("MachineName", values?.MachineName);
    formData.append("ManufacturingCompany", values?.ManufacturingCompany);
    formData.append("SerialNo", values?.SerialNo ? values?.SerialNo : "");
    formData.append(
      "MachineNumber",
      values?.MachineNumber ? values?.MachineNumber : "",
    );
    formData.append("CalibrationValidity", values?.CalibrationValidity);
    formData.append("IsCalibrationValidity", values?.IsCalibrationValidity);

    // formData.append("MachineGroupIDEncrypt", values?.MachineGroupIDEncrypt);
    formData.append(
      "MachineGroupIDs",
      Array.from(values.MachineGroupIDs, (x) => x.value).join(","),
    );

    formData.append("Remarks", values?.Remarks ? values?.Remarks : "");
    formData.append(
      "MachineRange",
      values?.MachineRange ? values?.MachineRange : "",
    );
    formData.append("UserManualFilePath", userManualFilePath);
    formData.append("MachineImage", machineImageFile);
    formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
    formData.append("BranchIDEncrypt", AuthUser?.BranchIDEncrypt);

    formData.append(
      "CreatedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );
    formData.append(
      "ModifiedByEncrypt",
      AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0",
    );
    formData.append("MachineImageURL", values?.MachineImageURL);
    formData.append("UserManualFilePathURL", values?.UserManualFilePathURL);

    values?.ListMachineParameters?.map((x, i) => {
      formData.append(
        `MachineParametersListDetail[${i}].MachineParameterIDEncrypt`,
        x.MachineParameterIDEncrypt,
      );
      formData.append(
        `MachineParametersListDetail[${i}].MachineIDEncrypt`,
        x.MachineIDEncrypt,
      );
      formData.append(
        `MachineParametersListDetail[${i}].MachineParameter`,
        x.MachineParameter,
      );
      formData.append(
        `MachineParametersListDetail[${i}].IsDeleted`,
        x.IsDeleted,
      );
    });

    postFormData(
      PrimaryIdParam ? POST_MachinesUpdate : POST_MachinesInsert,
      formData,
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          successMessage(response?.Message);
          setTimeout(() => {
            navigate("/machines");
          }, 1000);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getMachinesGroupDDL();
    if (MachineIDEncrypt) {
      GetMachinesDetail();
    }
  }, []);

  const getMachinesGroupDDL = () => {
    setIsLoading(true);
    post(POST_GetMaterialCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 3, // 1 = Machines Group
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setMachineGroupOptions(
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.MaterialCategoryIDEncrypted,
            })),
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const GetMachinesDetail = () => {
    setIsLoading(true);
    post(POST_GetMachinesDetailByID, {
      MachineIDEncrypt: window.atob(PrimaryIdParam),
    })
      .then((response) => {
        if (response?.IsSuccess) {
          let listMachineGroup = response?.ListOfMachineGroupDetail;

          formik.setValues({
            ...response,
            IsCalibrationValidity: response?.IsCalibrationValidity,

            ListMachineParameters: response?.ListOfMachineParameters?.map(
              (x) => ({
                ...x,
                IsDeleted: false,
              }),
            ),
            MachineGroupIDs:
              listMachineGroup.length > 0
                ? listMachineGroup.map((x) => ({
                    label: x.MachineGroupName,
                    value: x.MachineGroupIDEncrypt,
                  }))
                : "",
          });
          setMachineImage(response?.MachineImage);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const fnCallback = () => {
    GetMachinesDetail();
  };

  const uploadUserManualFilePath = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      //var pattern = /image-*/;
      //var pattern = /(doc|docx|pdf|xls|xlsx)$/;
      // if (!file.type.match(pattern)) {
      if (!file) {
        setUserManualFilePath(null);
        setUserManualFilePathFile(null);
        warningMessage("Select valid file!");
      } else {
        setUserManualFilePath(file);
        setUserManualFilePathFile(URL.createObjectURL(file));
      }
    }
  };

  const uploadMachineImage = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /image-*/;
      if (!file.type.match(pattern)) {
        setMachineImage(null);
        setMachineImageFile(null);
        warningMessage("Select valid image file!");
      } else {
        setMachineImageFile(file);
        setMachineImage(URL.createObjectURL(file));
      }
    }
  };

  const editMachineParameters = (i) => {
    //alert(i);
    //console.log("List", ListMachineParameters);
    let editData = ListMachineParameters?.filter((x, idx) => idx == i)[0];
    formik.setFieldValue("MachineParameter", editData.MachineParameter.trim());
    formik.setFieldValue(
      "MachineParameterID",
      editData.MachineParameterIDEncrypt.trim(),
    );
    formik.setFieldValue("indx", i);
    formik.setFieldValue("actionFlag", 1); // 1 = edit
  };

  const setAddMachineParameterName = () => {
    let parameterExist = false;

    if (!MachineParameter?.trim()) {
      //errorMessage("Machine Parameter is required field");
      formik.setFieldError(
        "MachineParameter",
        "Machine Parameter is required field",
      );
      formik.setFieldTouched("MachineParameter", true);
    } else {
      if (actionFlag == 0) {
        ListMachineParameters?.map((x, idx) => {
          if (
            x.MachineParameter.trim().toLocaleLowerCase() ===
            MachineParameter.trim().toLocaleLowerCase()
          ) {
            parameterExist = true;
          }
        });
      } else {
        ListMachineParameters?.map((x, idx) => {
          if (
            idx != indx &&
            x.MachineParameter.trim().toLocaleLowerCase() ===
              MachineParameter.trim().toLocaleLowerCase()
          ) {
            parameterExist = true;
          }
        });
      }

      if (parameterExist === true) {
        warningMessage("Machine Parameter is already existed");

        formik.setFieldValue("MachineParameter", "");
        formik.setFieldValue("indx", "");
        formik.setFieldValue("actionFlag", 0); // 0 = Add

        return;
      }

      if (indx > -1) {
        // ListMachineParameters?.map((x, idx) => {
        //   if (
        //     idx != indx &&
        //     x.MachineParameter.trim().toLocaleLowerCase() ===
        //       MachineParameter.trim().toLocaleLowerCase()
        //   ) {
        //     parameterExist = true;
        //   }
        // });
        if (actionFlag == 1) {
          if (parameterExist === false) {
            formik.setFieldValue(
              "ListMachineParameters",
              ListMachineParameters?.map((x, idx) => {
                if (idx == indx) {
                  return {
                    ...x,
                    MachineParameter: MachineParameter.trim(),
                    IsDeleted: false,
                  };
                } else {
                  return {
                    ...x,
                    IsDeleted: false,
                  };
                }
              }),
            );
          } else {
            warningMessage("Machine Parameter is already existed");
            formik.setFieldValue("MachineParameter", "");
            formik.setFieldValue("indx", "");
            formik.setFieldValue("actionFlag", 0); // 0 = Add
          }
        } else {
          if (parameterExist === false) {
            formik.setFieldValue("ListMachineParameters", [
              ...ListMachineParameters,
              {
                MachineParameter: MachineParameter.trim(),
                MachineParameterIDEncrypt: "0",
                MachineIDEncrypt: "0",
                IsDeleted: false,
                IsActive: true,
              },
            ]);
          } else {
            warningMessage("Machine Parameter is already existed");
            formik.setFieldValue("MachineParameter", "");
            formik.setFieldValue("indx", "");
            formik.setFieldValue("actionFlag", 0); // 0 = Add
          }
        }
      }
      formik.setFieldValue("MachineParameter", "");
      formik.setFieldValue("indx", "");
      formik.setFieldValue("actionFlag", 0); // 0 = Add
    }
  };

  const numberInputOnWheelPreventChange = (e) => {
    let isFocused = false;
    if (document.activeElement == e.target) {
      isFocused = true;
    }

    // Prevent the input value change
    e.target.blur();

    // Prevent the page/container scrolling
    e.stopPropagation();

    if (isFocused) {
      // Refocus immediately, on the next tick (after the current function is done)
      setTimeout(() => {
        e.target.focus();
      }, 0);
    }
  };

  const numberInputKeyDownPreventChange = (e) => {
    const key = e.charCode || e.keyCode;

    // Disable Up and Down Arrows on Keyboard
    // Also Prevent .(dot - 110,190) +(plus - 107,187) -(minus - 109,189) e(69)
    if (
      key === 38 ||
      key === 40 ||
      key === 190 ||
      key === 110 ||
      key === 107 ||
      key === 187 ||
      key === 109 ||
      key === 189 ||
      key === 69
    ) {
      e.preventDefault();
    } else {
      return;
    }
  };

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam ? "Edit" : "Add"} Machines
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col
                    lg={
                      AuthUser?.Permissions?.DT == 1 ||
                      AuthUser?.Permissions?.FoodTesting == 1
                        ? 8
                        : 12
                    }
                  >
                    <div
                      className="card mb-2"
                      style={{
                        height: "auto",
                        border: `${
                          AuthUser?.Permissions?.DT == 1 ||
                          AuthUser?.Permissions?.FoodTesting == 1
                            ? "1px solid #E6E6E6"
                            : "none"
                        }`,
                      }}
                    >
                      <div className="card-body p-2">
                        <Row>
                          <Col
                            lg={
                              AuthUser?.Permissions?.DT == 1 ||
                              AuthUser?.Permissions?.FoodTesting == 1
                                ? 4
                                : 3
                            }
                          >
                            <Field
                              label="Machine Name"
                              name="MachineName"
                              placeholder={"Enter Machine Name"}
                              component={CustomInput}
                              required
                              maxLength={100}
                              autoFocus
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "MachineName",
                                  capitalizeString(e?.target?.value),
                                );
                              }}
                            />
                          </Col>
                          <Col
                            lg={
                              AuthUser?.Permissions?.DT == 1 ||
                              AuthUser?.Permissions?.FoodTesting == 1
                                ? 4
                                : 3
                            }
                          >
                            <Field
                              label="Manufacturing Company"
                              name="ManufacturingCompany"
                              placeholder={"Enter Manufacturing Company"}
                              component={CustomInput}
                              maxLength={200}
                              onChange={(e) => {
                                formik.setFieldValue(
                                  "ManufacturingCompany",
                                  capitalizeString(e?.target?.value),
                                );
                              }}
                            />
                          </Col>
                          <Col
                            lg={
                              AuthUser?.Permissions?.DT == 1 ||
                              AuthUser?.Permissions?.FoodTesting == 1
                                ? 4
                                : 3
                            }
                          >
                            <Field
                              label="Serial No"
                              name="SerialNo"
                              placeholder={"Enter Serial No"}
                              component={CustomInput}
                              maxLength={50}
                            />
                          </Col>
                          <Col
                            lg={
                              AuthUser?.Permissions?.DT == 1 ||
                              AuthUser?.Permissions?.FoodTesting == 1
                                ? 4
                                : 3
                            }
                          >
                            <Field
                              label="Machine Number"
                              name="MachineNumber"
                              placeholder={"Enter Machine Number"}
                              component={CustomInput}
                              maxLength={50}
                            />
                          </Col>

                          {/* <Col lg={4}>
                            <Field
                              type="number"
                              label="Calibration Validity"
                              name="CalibrationValidity"
                              placeholder={"Enter Calibration Validity"}
                              component={CustomInput}
                              maxLength={50}
                            />
                          </Col> */}

                          <Col
                            lg={
                              AuthUser?.Permissions?.DT == 1 ||
                              AuthUser?.Permissions?.FoodTesting == 1
                                ? 4
                                : 3
                            }
                          >
                            <Field
                              label="Machine Range"
                              name="MachineRange"
                              placeholder={"Enter Machine Range"}
                              component={CustomInput}
                              maxLength={50}
                            />
                          </Col>
                          <Col
                            lg={
                              AuthUser?.Permissions?.DT == 1 ||
                              AuthUser?.Permissions?.FoodTesting == 1
                                ? 4
                                : 3
                            }
                          >
                            <div className="d-flex justify-content-between">
                              <label className="mb-1">
                                User Manual File Path{" "}
                              </label>
                              {UserManualFilePath ? (
                                <Link
                                  to="#"
                                  className="fs-14"
                                  onClick={() => {
                                    window.open(UserManualFilePath, "_blank");
                                  }}
                                >
                                  <i className="fa fa-download"></i> Download
                                </Link>
                              ) : (
                                ""
                              )}
                            </div>
                            <input
                              type="file"
                              id="fileUpload"
                              className="form-control form-control-sm"
                              // accept="image/png, image/gif, image/jpeg,.xls, .xlsx,.doc,.docx,application/pdf"
                              onChange={uploadUserManualFilePath}
                            />
                            <label htmlFor="fileUpload" name=""></label>
                          </Col>
                          {/* </Row>
                        <Row> */}
                          {/* <Col lg={AuthUser?.Permissions?.DT == 1 ? 4 : 3}>
                            <Row> */}
                          {AuthUser?.Permissions?.MachineMaintenance == 1 ? (
                            <Col
                              lg={
                                AuthUser?.Permissions?.DT == 1 ||
                                AuthUser?.Permissions?.FoodTesting == 1
                                  ? 4
                                  : 3
                              }
                            >
                              <div className="mb-2">
                                <label className="mb-1">
                                  Calibration Validity (In Months)
                                </label>
                                <div className="input-group">
                                  <div className="input-group-text">
                                    <input
                                      type="checkbox"
                                      className="form-check-input mt-0"
                                      id="IsCalibrationValidity"
                                      checked={IsCalibrationValidity}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          "IsCalibrationValidity",
                                          e?.target?.checked,
                                        );
                                      }}
                                    />
                                  </div>
                                  <input
                                    type="number"
                                    name="CalibrationValidity"
                                    placeholder={
                                      "Calibration Validity (In Months)"
                                    }
                                    autoComplete={"off"}
                                    className="form-control form-control-sm"
                                    value={CalibrationValidity}
                                    maxLength={2}
                                    disabled={
                                      IsCalibrationValidity ? false : true
                                    }
                                    // numberTypeWithoutDot={true}
                                    onWheel={numberInputOnWheelPreventChange} // to Prevent the input value change on mouse scroll
                                    onKeyDown={numberInputKeyDownPreventChange} // to Disable Up and Down Arrows on Keyboard
                                    onChange={(e) => {
                                      if (e?.target?.value < 100) {
                                        formik.setFieldValue(
                                          "CalibrationValidity",
                                          e?.target?.value ?? "",
                                        );
                                      }
                                    }}
                                  />
                                </div>
                                <ErrorMessage
                                  name={"CalibrationValidity"}
                                  component="div"
                                  className="invalid-feedback animated fadeInUp"
                                  style={{ display: "block" }}
                                />
                              </div>
                            </Col>
                          ) : (
                            ""
                          )}
                          <Col
                            lg={
                              AuthUser?.Permissions?.DT == 1 ||
                              AuthUser?.Permissions?.FoodTesting == 1
                                ? 4
                                : 3
                            }
                          >
                            <Field
                              label="Machine Group"
                              name="MachineGroupIDs"
                              placeholder={"Select Machine Group"}
                              component={CustomMultiSelect}
                              options={machineGroupOptions}
                              isMulti={true}
                              isClearable={true}
                            />
                          </Col>
                          {/* </Row>
                          </Col> */}
                          <Col
                            lg={
                              AuthUser?.Permissions?.DT == 1 ||
                              AuthUser?.Permissions?.FoodTesting == 1
                                ? 4
                                : 3
                            }
                          >
                            <Field
                              label="Remarks"
                              name="Remarks"
                              placeholder={"Enter Remarks"}
                              // component={CustomTextArea}
                              // rows={5}
                              component={CustomInput}
                              maxLength={500}
                            />
                          </Col>
                          <Col
                            lg={
                              AuthUser?.Permissions?.DT == 1 ||
                              AuthUser?.Permissions?.FoodTesting == 1
                                ? 4
                                : 3
                            }
                          >
                            <label className="mb-1">Machine Image</label>
                            <div
                              className="image-placeholder square-placeholder"
                              style={{ marginTop: "-2px" }}
                            >
                              <div className="avatar-edit">
                                <input
                                  type="file"
                                  id="imageUpload"
                                  accept="image/png, image/gif, image/jpeg"
                                  onChange={uploadMachineImage}
                                />
                                <label htmlFor="imageUpload" name=""></label>
                              </div>
                              <div
                                id="removeFile"
                                className="avatar-delete"
                                onClick={() => {
                                  setMachineImageFile(null);
                                  setMachineImage(null);
                                  formik.setFieldValue("MachineImageURL", "");
                                }}
                              >
                                <label htmlFor="removeFile" name=""></label>
                              </div>
                              <div className="avatar-preview">
                                <div id="imagePreview">
                                  <img
                                    id="saveImageFile"
                                    src={machineImage ? machineImage : img200}
                                    alt={"Machine Image"}
                                  />
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  {(AuthUser?.Permissions?.DT == 1 ||
                    AuthUser?.Permissions?.FoodTesting == 1) && (
                    <Col lg={4}>
                      <Row>
                        <Col lg={12}>
                          <div className="card mb-2" style={{ height: "auto" }}>
                            <div className="card-body p-2">
                              <div className="d-flex  mb-1">
                                <Field
                                  label="Machine Parameter"
                                  name="MachineParameter"
                                  placeholder={"Enter Machine Parameter"}
                                  component={CustomInput}
                                  maxLength={150}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "MachineParameter",
                                      //capitalizeString(e),
                                      e?.target?.value,
                                    );
                                  }}
                                  // required
                                />
                                &nbsp;&nbsp;&nbsp;
                                <label style={{ marginTop: "22px" }}>
                                  <button
                                    type="button"
                                    // className="btn btn-sm btn-primary"
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={(e) => {
                                      setAddMachineParameterName();
                                    }}
                                  >
                                    {actionFlag == 1 ? "Update" : "Add"}
                                  </button>
                                </label>
                              </div>
                              <div className="table-responsive active-projects style-1 shorting mb-2">
                                <div
                                  id="MachineParameters-tbl_wrapper"
                                  className="dataTables_wrapper no-footer"
                                >
                                  <table
                                    id="MachineParameters-tbl"
                                    className="table dataTable no-footer mb-0"
                                  >
                                    <thead>
                                      <tr>
                                        <th width="4%"></th>
                                        <th
                                          width="96%"
                                          style={{ textAlign: "left" }}
                                        >
                                          Machine Parameters Name
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {ListMachineParameters?.length > 0 ? (
                                        ListMachineParameters?.map(
                                          (item, indxMP) => (
                                            <tr
                                              key={
                                                item.MachineParameterIDEncrypt ||
                                                indxMP
                                              }
                                            >
                                              <td>
                                                <Link
                                                  to="#"
                                                  // className="icon-box icon-box-md bg-primary-light me-1"
                                                  className="icon-box icon-box-md me-1"
                                                  title="Edit"
                                                  onClick={() => {
                                                    editMachineParameters(
                                                      indxMP,
                                                    );
                                                  }}
                                                >
                                                  {SVGICON.EditPrimary}
                                                </Link>
                                                <Link
                                                  to="#"
                                                  // className={`icon-box icon-box-md bg-${
                                                  //   item.IsActive == true
                                                  //     ? "success"
                                                  //     : "danger"
                                                  // }-light me-1`}
                                                  className={`icon-box icon-box-md me-1`}
                                                  title={
                                                    item.IsActive == true
                                                      ? "Active"
                                                      : "Inactive"
                                                  }
                                                  onClick={() => {
                                                    ActiveInactive_Record(
                                                      item.IsActive,
                                                      POST_MachineParametersActiveInActive,
                                                      {
                                                        MachineParameterIDEncrypt:
                                                          item.MachineParameterIDEncrypt,
                                                        IsActive:
                                                          !item.IsActive,
                                                        ModifiedByEncrypted:
                                                          AuthUser?.ReferenceIDEncrypt
                                                            ? AuthUser?.ReferenceIDEncrypt
                                                            : "0",
                                                      },
                                                      setIsLoading,
                                                      fnCallback,
                                                      item.MachineParameter,
                                                    );
                                                  }}
                                                >
                                                  <i
                                                    className={`fa fa-circle fs-15 ${
                                                      item.IsActive == true
                                                        ? "text-success"
                                                        : "text-danger"
                                                    }`}
                                                  ></i>
                                                </Link>
                                              </td>
                                              <td style={{ textAlign: "left" }}>
                                                {item.MachineParameter}
                                              </td>
                                            </tr>
                                          ),
                                        )
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={3}
                                            style={{ textAlign: "left" }}
                                          >
                                            <div>{"No Record Found..."}</div>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  )}
                </Row>
                <hr className="mt-1 mb-2"></hr>
                <button
                  type="submit"
                  // className="btn btn-primary"
                  className="btn btn-primary btn-sm me-2"
                >
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  // className="btn btn-danger light"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>

        {/* <Modal
          className="fade"
          show={addMachineParametersModal}
          onHide={setAddMachineParametersModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikMachineParametersDetail}>
              <Form onSubmit={formikMachineParametersDetail.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Machine Parameters</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setAddMachineParametersModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label="Machine Parameter"
                        name="MachineParameter"
                        placeholder={"Enter Machine Parameter"}
                        component={CustomInput}
                        maxLength={150}
                        required
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="primary" type="submit">
                    {actionFlag == 1 ? "Update" : "Add"}
                  </Button>
                  <Button
                    variant="danger light"
                    onClick={() => setAddMachineParametersModal(false)}
                  >
                    Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal> */}
      </div>
    </div>
  );
};

export default AddMachines;
